/**
 * 配置工具类
 * 用于管理API基础URL和图片URL处理
 */

// 获取API基础URL
export function getApiBaseUrl() {
  return process.env.VUE_APP_API_BASE_URL || 'https://zdt.sxyqyf.com/api/v1'
}

// 获取文件服务器基础URL（用于图片等静态资源）
export function getFileBaseUrl() {
  const apiUrl = getApiBaseUrl()
  return apiUrl.replace('/api/v1', '')
}

// 处理图片URL
export function processImageUrl(url) {
  if (!url) return ''
  
  const baseUrl = getFileBaseUrl()
  const originalUrl = url
  
  // 如果是相对路径，添加基础路径
  if (url.startsWith('/')) {
    const processedUrl = `${baseUrl}${url}`
    console.log('图片URL处理 - 相对路径:', originalUrl, '=>', processedUrl)
    return processedUrl
  }
  
  // 如果是完整URL但端口错误，替换为正确的地址
  if (url.includes('localhost:8001') || url.includes('localhost:8000') || url.includes('localhost:3000') || url.includes('localhost:8080')) {
    try {
      const urlObj = new URL(url)
      const processedUrl = `${baseUrl}${urlObj.pathname}`
      console.log('图片URL处理 - 错误端口:', originalUrl, '=>', processedUrl)
      return processedUrl
    } catch (e) {
      console.warn('URL解析失败:', url, e)
    }
  }
  
  // 如果URL包含错误的IP或端口，进行替换
  if (url.startsWith('http://') || url.startsWith('https://')) {
    try {
      const urlObj = new URL(url)
      const targetHost = new URL(baseUrl).host
      if (urlObj.host !== targetHost) {
        const processedUrl = `${baseUrl}${urlObj.pathname}`
        console.log('图片URL处理 - 错误主机:', originalUrl, '=>', processedUrl)
        return processedUrl
      }
    } catch (e) {
      console.warn('URL解析失败:', url, e)
    }
  }
  
  // 如果是完整URL且地址正确，直接返回
  console.log('图片URL处理 - 无需处理:', originalUrl)
  return url
}

// 检查图片URL是否可访问
export function checkImageUrl(url) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(true)
    img.onerror = () => reject(false)
    img.src = url
  })
}

// 获取带时间戳的URL（用于强制刷新）
export function getUrlWithTimestamp(url) {
  if (!url) return ''
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}t=${Date.now()}`
} 